import { useContext } from 'react'
import { ToastContext } from '../contexts/ToastContextDef'

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within ToastProvider')
  }
  return context
}
